import { useMemo } from 'react';
import { NextPage } from 'next';

import { PageSection } from 'types/pages';

import Head from 'components/layout/Head';
import PageContainer from 'components/layout/PageContainer';
import SectionsWrapper from 'components/layout/SectionsWrapper';

import SectionContent from './sections/Content';
import StyledComponent from './styles';
import { Props } from './types';

const PageRegulations: NextPage<Props> = ({ localTranslations, metaTranslations }) => {
    const sections: PageSection[] = useMemo(() => [{
        slug: 'content',
        order: 1,
        isVisible: true,
        children: (slug, translations) => (
            <SectionContent
                key={slug}
                translations={translations}
            />
        ),
    }], []);

    return (
        <StyledComponent className="page-regulations">
            <Head
                {...metaTranslations}
            />
            <PageContainer>
                <SectionsWrapper
                    sections={sections}
                    localTranslations={localTranslations}
                />
            </PageContainer>
        </StyledComponent>
    );
};

export default PageRegulations;
